module.exports = __webpack_public_path__ + "img/undraw_Portfolio_update_re_jqnp (1).65855ac7.svg";